import React, { useEffect } from 'react';
import { Gql } from '@fiverr-private/dynamic_matching';
import { Container } from '@fiverr-private/layout_components';
import { useBriefContext } from '@fiverr-private/ai_brief/dist/esm/src/common/BriefContext';
import { getContext } from '@fiverr-private/fiverr_context';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { useGetCurrentFlow } from '../../hooks';
import { briefCreationDrawerEducationIsShown } from '../../monitoring/bqEvents';
import { Step } from '../../constants';
import { AuctionFlowHighlight, InviteFlowHighlight } from './Highlights';

interface RoutingIndicatorProps {
  isEditMode?: boolean;
}

export const RoutingIndicator = ({ isEditMode = false }: RoutingIndicatorProps) => {
  const { contextId, source, buyerType, variant, initialStep, missingFieldsCount } = useBriefCreationContext();
  const { editedSectionId } = useBriefContext();
  const { isMobile } = getContext();
  const flow = useGetCurrentFlow();

  useEffect(() => {
    if (flow) {
      briefCreationDrawerEducationIsShown({
        educationType: 'flow_explainer',
        briefContextId: contextId,
        eventSource: source || '',
        variant,
      });
    }
  }, [flow, contextId, source, variant]);

  if (initialStep === Step.Edit && isEditMode) {
    return null;
  }

  const isDisabled = !!missingFieldsCount || !!editedSectionId;
  if (isMobile && isDisabled) {
    return null;
  }

  if (!flow) {
    return null;
  }

  const isRncBuyer = buyerType === Gql.BuyerType.RegisteredNotConverted;
  const auctionHighlight =
    flow === Gql.DmMatchCandidateCreationFlow.Auction && !isRncBuyer ? <AuctionFlowHighlight /> : null;
  const inviteHighlight = flow !== Gql.DmMatchCandidateCreationFlow.Auction ? <InviteFlowHighlight /> : null;

  if (!auctionHighlight && !inviteHighlight) {
    return null;
  }

  return (
    <Container marginRight="auto" flex={{ sm: '1' }}>
      {auctionHighlight}
      {inviteHighlight}
    </Container>
  );
};
